import ApiClient from '@services/ApiClient';

export default {
    processOrder(params) {
        return ApiClient.post('/travel/btm/process-order', params);
    },
};
